export default __webpack_public_path__ + "static/media/eth_w.9a178671.svg";